import {createStore} from "vuex"


export default new createStore({
    state: {
        cart_num: 0,//购物车数量
        is_login: false,//登录状态
        account_name: '',
        site_name: import.meta.env.VITE_APP_SITE_NAME,//网站全局名称
        service_email: 'business@niuniubox.com',//全局 客服邮箱
        site_domain: import.meta.env.VITE_APP_DOMAIN,//网址域名
        youtube: 'https://www.youtube.com/@niuniubox',
        TikTok: 'https://www.tiktok.com/@niuniubox',
        Facebook: 'https://www.facebook.com/niuniubox',
        Quora: 'https://www.quora.com/profile/niuniubox',
        Twitter: 'https://twitter.com/niuniubox',
        Pinterest: 'https://www.pinterest.com/niuniubox',
        AliPayEmail: '',
        PayoneerEmail: '',

    },
    mutations: {
        changeCart(state, cart_num) {
            console.log('Changing cart count to:', cart_num);
            state.cart_num = cart_num
        },
        changeLoginStatus(state, loginStatus) {
            state.is_login = loginStatus
        },
        setAccountName(state, name) {
            state.account_name = name
        },
    },
})
